<template>
  <div class="container p-0">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto mt-auto mb-auto">
      <card class="card-login card-white text-left m-0">
        <form @submit.prevent="loginEmpresaF">
          <img width="200" class="rounded mx-auto d-block p-0" src="../../assets/img/logo3.png" />

          <div>
            <base-input v-if="tipoLogin === 'false'" type="tel" v-mask="'##.###.###/####-##'"
              v-model="loginEmpresa.cnpj" placeholder="CNPJ" addon-left-icon="tim-icons icon-bank">
            </base-input>

            <base-input v-else type="tel" v-mask="'###.###.###-##'" v-model="loginEmpresa.cpf" placeholder="CPF"
              addon-left-icon="tim-icons icon-bank">
            </base-input>

            <base-input name="password" v-model="loginEmpresa.senha" type="password" placeholder="Senha"
              addon-left-icon="tim-icons icon-lock-circle">
            </base-input>
          </div>

          <div class="col-sm-10 checkbox-radios d-flex flex-row p-0">
            <base-radio name="true" v-model="tipoLogin" class="mr-3">CPF</base-radio>
            <base-radio name="false" v-model="tipoLogin">CNPJ</base-radio>
          </div>

          <div slot="footer">
            <base-button native-type="submit" type="success" class="mb-3" size="lg" block
              :disabled="disabledBtnEntrarE()">
              Entrar
            </base-button>


          </div>
        </form>
        <base-button @click="acessarLoginUsuario()" native-type="submit" type="success" class="mb-1" size="lg" block>
          Acesso ao RH
        </base-button>
      </card>
    </div>

    <Carregando v-if="isLoading" />
  </div>
</template>

<script>
import { Card, BaseInput } from "@/components/index";
import Carregando from "../../../src/pages/Loads/Carregando.vue";
import swal from "sweetalert2";

import jwt from "jsonwebtoken";
import globalVariable from "../../globalVariable";

export default {
  components: {
    Card,
    BaseInput,
    Carregando,
  },
  data() {
    return {
      isLoading: false,
      tipoLogin: "false", //0 - cpf / 1 - cnpj
      tipoLoginFunc: "true",
      coordenadas: [],
      loginFuncionario: {
        cnpj: "",
        senha: "",
        cpf: "",
      },
      loginEmpresa: {
        cnpj: "",
        cpf: "",
        senha: "",
      },
      itemMenu: 1,
      model: {
        cnpj: "",
        cpf: "",
        password: "",
        subscribe: true,
      },
    };
  },
  mounted() {
    this.$root.$on("voltarMenuLogin", () => {
      this.itemMenu = 1;
    });

    this.$getLocation().then((coordinates) => {
      this.coordenadas = coordinates;
    });
  },
  methods: {
    acessarLoginUsuario() {
      this.$router.push("/loginUsuario");
    },
    disabledBtnEntrarF() {
      if (this.tipoLoginFunc === "true") {
        if (
          this.loginFuncionario.cnpj.length == 18 &&
          this.loginFuncionario.cpf.length == 14
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        if (
          this.loginFuncionario.cnpj.length == 18 &&
          this.loginFuncionario.senha.length > 5
        ) {
          return false;
        } else {
          return true;
        }
      }
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    clickCard(param) {
      this.$root.$emit("showV");
      this.itemMenu = param;
    },

    disabledBtnEntrarE() {
      if (
        this.loginEmpresa.cnpj.length == 18 &&
        this.loginEmpresa.senha.length > 5
      ) {
        return false;
      } else {
        return true;
      }
    },

    async loginEmpresaF() {
      let th = this;
      let cpf_cnpj = "";
      this.isLoading = true;
      if (this.tipoLogin == "false") {
        cpf_cnpj = this.loginEmpresa.cnpj.replace(/[. - / - -]/g, "");
      } else {
        cpf_cnpj = this.loginEmpresa.cpf.replace(/[. - / - -]/g, "");
      }

      let bodyFormData = {
        cpf_cnpj_login: cpf_cnpj,
        passwd: this.loginEmpresa.senha,
        valida_status: true
      };

      this.axios
        .post("/api/login/loginEmpregador", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          if (!response) {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao tentar acessar o sistema. Por favor entre em contato com o suporte",
              "error"
            );
          } else {
            const expirationTime = 2 * 60 * 60; // 2 horas em segundos (28.800 segundos)

            const response_dados = response.data.data
            if (response_dados.status) {
              let dados = response.data.data.dados[0];
              let w1 = jwt.sign(
                { foo: "bar", exp: Math.floor(Date.now() / 1000) + 2 * (60 * 60) }, // expira em 8 horas
                globalVariable.KEY_LEVEL_5
              );

              th.$cookies.set("w_", w1, expirationTime);
              th.$cookies.set("cnpj", dados.cnpj_login);
              th.$cookies.set("db", dados.db_name);
              th.$cookies.set("nome_empresa", dados.nome)
              th.$cookies.set(
                "token",
                "sbchascas6aa6sd34h23vg42v3hg4gh234vhg234vgh2",
                expirationTime
              );
              th.recuperarDados(dados.db_name, "/home", dados.cnpj_login);
            } else {
              th.showSwal(
                "auto-close",
                "Erro",
                response_dados.err || "Erro ao tentar acessar o sistema. Por favor entre em contato com o suporte",
                "error"
              );
            }
          }

        })
        .catch((err) => {
          th.isLoading = false;
          const error_msg = err.response ? err.response.data.data.err : "Erro ao tentar acessar o sistema. Por favor entre em contato com o suporte"
          console.log(err.response)
          th.showSwal(
            "auto-close",
            "Erro",
            error_msg,
            "error"
          );
          // warning, error, success, info, and question
        });
    },

    recuperarDados(db, route, cnpj) {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: db,
        cpf_cnpj: cnpj,
      };

      this.axios
        .post("/api/empregador/listarEmpregadorPorCpfCpnj", bodyFormData)
        .then((response) => {
          let dados = response.data.data.dados[0];
          th.isLoading = false;
          th.$cookies.set("idEmpregador", dados.id);
          th.$router.push(route);
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao recuperar dados!",
            "error"
          );
        });
    },
  },
};
</script>

<style>
.full-page>.content {
  padding-top: 10%;
}
</style>
